import { FunctionsService } from './../services/functions.service';
import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';
import { OperatorService } from '../services/operator.service';

declare const $: any;

// Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

// Menu Items
export const ROUTES: RouteInfo[] = [{
    //     path: '/init',
    //     title: 'Inicio',
    //     type: 'link',
    //     icontype: 'insert_chart'
    // }, {
    path: '/student',
    title: 'Alumnos',
    type: 'link',
    icontype: 'group'
}, {
    path: '/assistance',
    title: 'Asistencias',
    type: 'link',
    // icontype: 'how_to_reg'
    icontype: 'playlist_add_check'
},  {
    path: '/academicconfiguration',
    title: 'Configuración Académica',
    type: 'link',
    icontype: 'school'
},
{
    path: '/reportCards/start',
    title: 'Boletin Unico Digital',
    type: 'link',
    icontype: 'note'
},
{
    path: '/equivalences/start',
    title: 'Saberes Adquiridos/Equivalencias',
    type: 'link',
    icontype: 'class'
},
{
    path: '/',
    title: 'Personal',
    type: 'sub',
    icontype: 'portrait',
    children: [
        { path: 'staff', title: 'Cargos', ab: 'C' },
        { path: 'licenses', title: 'Licencias', ab: 'L' }
    ]
},
{
    path: '/incidence',
    title: 'Incidencias',
    type: 'link',
    icontype: 'assignment_late'
}, {
    path: '/operator',
    title: 'Operadores',
    type: 'link',
    icontype: 'supervisor_account'
}, {
    path: '/profile',
    title: 'Perfiles',
    type: 'link',
    icontype: 'face'
}, /* {
    path: '/averages',
    title: 'Promedios',
    type: 'link',
    icontype: 'bookmark'
    }, */
{
    path: '/reports',
    title: 'Reportes',
    type: 'link',
    icontype: 'report'
}, {
    path: '/evaluations',
    title: 'Evaluaciones',
    type: 'link',
    icontype: 'done_outline'
}, 
{
    path: '/specialTests',
    title: 'Evaluaciones especiales',
    type: 'link',
    icontype: 'assignment_late'
},
{
    path: '/communication',
    title: 'Comunicación y Circulares',
    type: 'link',
    icontype: 'chat'
},
{
    path: '/notifications',
    title: 'Notificaciones',
    type: 'link',
    icontype: 'notifications'
},
{
    path: '/dashboard',
    title: 'Resumenes',
    type: 'link',
    icontype: 'assessment'
},
{
    path: '/previoussubject/start',
    title: 'Previas',
    type: 'link',
    icontype: 'book'
},
{
    path: '/analyticaltitles/start',
    title: 'Títulos Analíticos',
    type: 'link',
    icontype: 'assignment_turned_in'
}];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html'
})

export class SidebarComponent implements OnInit {
    operatorId: any;
    operatorRoles: any[] = [];
    isInitialLevel:boolean = false;

    public menuItems: any[];
    user: any;
    person: any;
    operatorIsTeacher: any;
    isEpda: boolean;
    operatorIsDirector: any;
    constructor(private authenticationService: AuthenticationService, private operatorService: OperatorService, private functionsService: FunctionsService) {
        this.user = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).authToken.claims.scopes : null;
        this.person = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).person : null;
        const levelCode = JSON.parse(localStorage.getItem('educationalCenters')) ? JSON.parse(localStorage.getItem('educationalCenters')).level.code : '';
        if(levelCode === 'NIVEL INICIAL'){
            this.isInitialLevel = true;
        }
        this.isEpda = this.functionsService.isEpda();
    }

    isNotMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        const isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            const $sidebar = $('.sidebar-wrapper');
            $sidebar.perfectScrollbar();
            // if we are on windows OS we activate the perfectScrollbar function
            $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
            $('html').addClass('perfect-scrollbar-on');
        } else {
            $('html').addClass('perfect-scrollbar-off');
        }
        const systemOwner = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).authToken.claims.scopes.systemOwner : false;
        this.operatorId = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).person.operatorId : 0;
        this.getOperatorIsTeacher();
        this.getOperatorIsDirector();
        if (!systemOwner && this.operatorId > 0) {
            this.operatorService.getRolesByOperatorId(this.operatorId).subscribe((response: any) => {
                this.operatorRoles = response;
                this.getMenu();
            });
        } else {
            this.getMenu();
        };
    }

    getMenu() {
        this.menuItems = ROUTES.filter(menuItem => {
            let selfManaged = JSON.parse(localStorage.getItem('educationalCenters')) ? 
            JSON.parse(localStorage.getItem('educationalCenters')).selfManaged : false;
            let generative =JSON.parse(localStorage.getItem('educationalCenters')) ? 
            JSON.parse(localStorage.getItem('educationalCenters')).generative : false;
            let privateEst = JSON.parse(localStorage.getItem('educationalCenters')) ? 
            JSON.parse(localStorage.getItem('educationalCenters')).private : false;
            let level =  JSON.parse(localStorage.getItem('educationalCenters')) ?
            JSON.parse(localStorage.getItem('educationalCenters')).level.name : '';
            if (menuItem.path !== '/') { 
                return (
                    (menuItem.title === 'Alumnos' && this.contains(this.operatorRoles, 'REGISTRATION_SHOW'))
                    || (menuItem.title === 'Asistencias' && this.contains(this.operatorRoles, 'ASSISTENCE_SHOW'))
                    || (menuItem.title === 'Configuración Académica' && this.contains(this.operatorRoles, 'POF_SHOW'))
                    || (menuItem.title === 'Boletin Unico Digital' && this.contains(this.operatorRoles, 'REPORT_CARD_SHOW'))
                    || (menuItem.title === 'Saberes Adquiridos/Equivalencias' && this.contains(this.operatorRoles, 'EQUIVALENCE_SHOW') && (level == 'SECUNDARIO')  && !this.isEpda)
                    || (menuItem.title === 'Incidencias' && this.contains(this.operatorRoles, 'INCIDENT_SHOW'))
                    || (menuItem.title === 'Operadores' && this.contains(this.operatorRoles, 'OPERATOR_SHOW'))
                    || (menuItem.title === 'Perfiles' && this.contains(this.operatorRoles, 'PROFILE_SHOW'))
                    || (menuItem.title === 'Promedios' && this.contains(this.operatorRoles, 'AVERAGE_SHOW'))
                    || (menuItem.title === 'Reportes' && this.contains(this.operatorRoles, 'REPORT_SHOW'))
                    || (menuItem.title === 'Resumenes' && this.contains(this.operatorRoles, 'REPORT_SHOW'))
                    || (menuItem.title === 'Evaluaciones' && this.contains(this.operatorRoles, 'TEST_SHOW'))
                    || (menuItem.title === 'Personal' )
                    || (menuItem.title === 'Evaluaciones especiales' && this.contains(this.operatorRoles, 'TEST_SHOW') && !this.isInitialLevel && !this.isEpda)
                    || (menuItem.title === 'Comunicación y Circulares' && (!this.operatorIsTeacher || this.operatorIsDirector) && this.contains(this.operatorRoles, 'PROFILE_SELECT') && (level != 'NIVEL SUPERIOR'))
                    || (menuItem.title === 'Previas' && this.contains(this.operatorRoles, 'EQUIVALENCE_SHOW') && !this.isEpda && !this.isInitialLevel && level != 'PRIMARIO')
                    || (menuItem.title === 'Títulos Analíticos' && this.contains(this.operatorRoles, 'ANALYTICAL_CERTIFICATE_CREATE') && (level == 'SECUNDARIO' || level == 'NIVEL SUPERIOR'))
                    || (menuItem.title === 'Notificaciones' && (level != 'NIVEL SUPERIOR'))

                    || menuItem.children);
            } else { 
                const isTrue: any[] = [];
                let ret = false;
                menuItem.children.forEach((child: any, index: any) => {
                    if (child.title === 'Operadores' && this.contains(this.operatorRoles, 'OPERATOR_SHOW')) {
                        ret = true;
                        isTrue.push(child);
                    } 
                   

                    if ((child.title === 'Cargos' && this.contains(this.operatorRoles, 'STAFF_SHOW') )
                        || (child.title === 'Licencias' && this.contains(this.operatorRoles, 'LICENSE_SHOW'))) {
                        ret = true;
                        isTrue.push(child);
                    }
                    else if (!ret) {
                        ret = false;
                    }
                });
                menuItem.children = isTrue;
                return ret;
            }
            
        });
    };

    contains(roles: any[], name: string) {
        const systemOwner = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).authToken.claims.scopes.systemOwner : false;
        if (systemOwner) {
            return true;
        } else {
            for (const rol of roles) {
                if (rol.name === name) {
                    return true;
                }
            }
            return false;
        }
    }

    logout() {
        this.authenticationService.logout();
    }

    public getOperatorIsTeacher() {
        this.operatorIsTeacher = JSON.parse(localStorage.getItem('educationalCenters')) ?
            JSON.parse(localStorage.getItem('educationalCenters')).operatorIsTeacher : '';
    }

    public getOperatorIsDirector() {
        this.operatorIsDirector = JSON.parse(localStorage.getItem('educationalCenters')) ?
            JSON.parse(localStorage.getItem('educationalCenters')).operatorIsDirector : '';
    }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/sidebar/sidebar.component.ts